import { getInstance } from './ga4-tracking';
import { slideDown, slideUp } from '../libs/sliding';
import { prefersReducedMotion } from '../utils/prefersReducedMotion';

function accordion() {
  const accordionList = Array.from(
    document.querySelectorAll('.c-accordion__item .c-accordion__toggle'),
  );

  accordionList.length &&
    accordionList.forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        const TrackingInstance = getInstance();
        const duration = prefersReducedMotion() ? 0 : 450;

        const item = toggle.closest('.c-accordion__item');
        const content = item.querySelector('.c-accordion__content');

        if (item.classList.contains('c-accordion__item--active')) {
          toggle.setAttribute('aria-expanded', false);
          item.classList.remove('c-accordion__item--active');
          slideUp(content, duration);
        } else {
          TrackingInstance.createEvent(
            'click-event',
            'accordion',
            e.currentTarget,
          );
          toggle.setAttribute('aria-expanded', true);
          item.classList.add('c-accordion__item--active');
          slideDown(content, duration);
        }
      });
    });
}

export function init() {
  accordion();
}
